(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7299],{

/***/ 50925:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 85737:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 48645:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ IconButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45746);
/* harmony import */ var _modules_Controller_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67228);
/* harmony import */ var _consts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97678);




const IconButton = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ label, className, icon: Icon, renderIcon, onClick, style, ...rest }, ref) => {
    const { styles } = (0,_modules_Controller_js__WEBPACK_IMPORTED_MODULE_1__/* .useController */ .bc)().getLightboxProps();
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", { ref: ref, type: "button", "aria-label": label, className: (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .clsx */ .Wy)((0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .cssClass */ .Nc)(_consts_js__WEBPACK_IMPORTED_MODULE_3__/* .ELEMENT_BUTTON */ .bg), className), onClick: onClick, style: { ...style, ...styles.button }, ...rest }, renderIcon ? renderIcon() : react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, { className: (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__/* .cssClass */ .Nc)(_consts_js__WEBPACK_IMPORTED_MODULE_3__/* .ELEMENT_ICON */ .vg), style: styles.icon })));
});
IconButton.displayName = "IconButton";


/***/ }),

/***/ 26668:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ho": function() { return /* binding */ LoadingIcon; },
/* harmony export */   "IU": function() { return /* binding */ createIcon; },
/* harmony export */   "Ne": function() { return /* binding */ NextIcon; },
/* harmony export */   "Pz": function() { return /* binding */ ErrorIcon; },
/* harmony export */   "Tw": function() { return /* binding */ CloseIcon; },
/* harmony export */   "jJ": function() { return /* binding */ PreviousIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const createIcon = (name, glyph) => {
    const icon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24", "aria-hidden": "true", focusable: "false", ...props },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", { fill: "currentColor" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
            glyph)));
    icon.displayName = name;
    return icon;
};
const CloseIcon = createIcon("Close", react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }));
const PreviousIcon = createIcon("Previous", react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }));
const NextIcon = createIcon("Next", react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }));
const LoadingIcon = createIcon("Loading", react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, Array.from({ length: 8 }).map((_, index, array) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement("line", { key: index, x1: "12", y1: "6.5", x2: "12", y2: "1.8", strokeLinecap: "round", strokeWidth: "2.6", stroke: "currentColor", strokeOpacity: (1 / array.length) * (index + 1), transform: `rotate(${(360 / array.length) * index}, 12, 12)` })))));
const ErrorIcon = createIcon("Error", react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z" }));


/***/ }),

/***/ 18733:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ImageSlide; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45746);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83744);
/* harmony import */ var _contexts_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31390);
/* harmony import */ var _Icons_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26668);
/* harmony import */ var _consts_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97678);






const slidePrefix = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .makeComposePrefix */ .cO)("slide");
const slideImagePrefix = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .makeComposePrefix */ .cO)("slide_image");
const ImageSlide = ({ slide: image, offset, render, rect, imageFit, onClick, onLoad, style, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const [status, setStatus] = react__WEBPACK_IMPORTED_MODULE_0__.useState(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_LOADING */ .Xe);
    const { publish } = (0,_contexts_index_js__WEBPACK_IMPORTED_MODULE_3__/* .useEvents */ .h)();
    const imageRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (offset === 0) {
            publish((0,_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .activeSlideStatus */ .J1)(status));
        }
    }, [offset, status, publish]);
    const handleLoading = (0,_hooks_index_js__WEBPACK_IMPORTED_MODULE_4__/* .useEventCallback */ .$)((img) => {
        if (status === _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_COMPLETE */ .Zv) {
            return;
        }
        ("decode" in img ? img.decode() : Promise.resolve())
            .catch(() => { })
            .then(() => {
            if (!img.parentNode) {
                return;
            }
            setStatus(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_COMPLETE */ .Zv);
            onLoad === null || onLoad === void 0 ? void 0 : onLoad(img);
        });
    });
    const setImageRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((img) => {
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) {
            handleLoading(img);
        }
    }, [handleLoading]);
    const handleOnLoad = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((event) => {
        handleLoading(event.currentTarget);
    }, [handleLoading]);
    const onError = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
        setStatus(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_ERROR */ .fS);
    }, []);
    const cover = image.imageFit === _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_FIT_COVER */ .rO || (image.imageFit !== _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_FIT_CONTAIN */ .j3 && imageFit === _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .IMAGE_FIT_COVER */ .rO);
    const nonInfinite = (value, fallback) => (Number.isFinite(value) ? value : fallback);
    const maxWidth = nonInfinite(Math.max(...((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map((x) => x.width)) !== null && _b !== void 0 ? _b : []).concat(image.width ? [image.width] : [])), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    const maxHeight = nonInfinite(Math.max(...((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map((x) => x.height)) !== null && _e !== void 0 ? _e : []).concat(image.height ? [image.height] : [])), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    const defaultStyle = maxWidth && maxHeight
        ? {
            maxWidth: `min(${maxWidth}px, 100%)`,
            maxHeight: `min(${maxHeight}px, 100%)`,
        }
        : {
            maxWidth: "100%",
            maxHeight: "100%",
        };
    const srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort((a, b) => a.width - b.width).map((item) => `${item.src} ${item.width}w`).join(", ");
    const estimateActualWidth = () => rect && !cover && image.width && image.height ? (rect.height / image.height) * image.width : Number.MAX_VALUE;
    const sizes = srcSet && rect && (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .hasWindow */ .Ym)() ? `${Math.round(Math.min(estimateActualWidth(), rect.width))}px` : undefined;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", { ref: setImageRef, onLoad: handleOnLoad, onError: onError, onClick: onClick, className: (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .Wy)((0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(slideImagePrefix()), cover && (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(slideImagePrefix("cover")), status !== _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_COMPLETE */ .Zv && (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(slideImagePrefix("loading"))), draggable: false, alt: image.alt, style: { ...defaultStyle, ...style }, sizes: sizes, srcSet: srcSet, src: image.src }),
        status !== _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_COMPLETE */ .Zv && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(slidePrefix(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_PLACEHOLDER */ .$L)) },
            status === _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_LOADING */ .Xe &&
                ((render === null || render === void 0 ? void 0 : render.iconLoading) ? (render.iconLoading()) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icons_js__WEBPACK_IMPORTED_MODULE_5__/* .LoadingIcon */ .Ho, { className: (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .Wy)((0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .ELEMENT_ICON */ .vg), (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(slidePrefix(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_LOADING */ .Xe))) }))),
            status === _consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_ERROR */ .fS &&
                ((render === null || render === void 0 ? void 0 : render.iconError) ? (render.iconError()) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icons_js__WEBPACK_IMPORTED_MODULE_5__/* .ErrorIcon */ .Pz, { className: (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .Wy)((0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .ELEMENT_ICON */ .vg), (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .cssClass */ .Nc)(slidePrefix(_consts_js__WEBPACK_IMPORTED_MODULE_2__/* .SLIDE_STATUS_ERROR */ .fS))) })))))));
};


/***/ }),

/***/ 36615:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ withPlugins; },
/* harmony export */   "dS": function() { return /* binding */ createNode; },
/* harmony export */   "l6": function() { return /* binding */ createModule; }
/* harmony export */ });
const createModule = (name, component) => ({
    name,
    component,
});
const createNode = (module, children) => ({
    module,
    children,
});
const traverseNode = (node, target, apply) => {
    if (node.module.name === target) {
        return apply(node);
    }
    if (node.children) {
        return [
            createNode(node.module, node.children.flatMap((n) => { var _a; return (_a = traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : []; })),
        ];
    }
    return [node];
};
const traverse = (nodes, target, apply) => nodes.flatMap((node) => { var _a; return (_a = traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : []; });
const withPlugins = (root, plugins) => {
    let config = root;
    const augmentations = [];
    const contains = (target) => {
        const nodes = [...config];
        while (nodes.length > 0) {
            const node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target)
                return true;
            if (node === null || node === void 0 ? void 0 : node.children)
                nodes.push(...node.children);
        }
        return false;
    };
    const addParent = (target, module) => {
        if (target === "") {
            config = [createNode(module, config)];
            return;
        }
        config = traverse(config, target, (node) => [createNode(module, [node])]);
    };
    const append = (target, module) => {
        config = traverse(config, target, (node) => [createNode(node.module, [createNode(module, node.children)])]);
    };
    const addChild = (target, module, precede) => {
        config = traverse(config, target, (node) => {
            var _a;
            return [
                createNode(node.module, [
                    ...(precede ? [createNode(module)] : []),
                    ...((_a = node.children) !== null && _a !== void 0 ? _a : []),
                    ...(!precede ? [createNode(module)] : []),
                ]),
            ];
        });
    };
    const addSibling = (target, module, precede) => {
        config = traverse(config, target, (node) => [
            ...(precede ? [createNode(module)] : []),
            node,
            ...(!precede ? [createNode(module)] : []),
        ]);
    };
    const replace = (target, module) => {
        config = traverse(config, target, (node) => [createNode(module, node.children)]);
    };
    const remove = (target) => {
        config = traverse(config, target, (node) => node.children);
    };
    const augment = (augmentation) => {
        augmentations.push(augmentation);
    };
    plugins === null || plugins === void 0 ? void 0 : plugins.forEach((plugin) => {
        plugin({
            contains,
            addParent,
            append,
            addChild,
            addSibling,
            replace,
            remove,
            augment,
        });
    });
    return {
        config,
        augmentation: (props) => augmentations.reduce((acc, augmentation) => augmentation(acc), props),
    };
};


/***/ }),

/***/ 97678:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ SLIDE_STATUS_PLACEHOLDER; },
/* harmony export */   "Bm": function() { return /* binding */ EVENT_ON_KEY_UP; },
/* harmony export */   "Eb": function() { return /* binding */ ACTION_NEXT; },
/* harmony export */   "HE": function() { return /* binding */ MODULE_NO_SCROLL; },
/* harmony export */   "J1": function() { return /* binding */ activeSlideStatus; },
/* harmony export */   "KN": function() { return /* binding */ ACTION_PREV; },
/* harmony export */   "M9": function() { return /* binding */ CLASS_NO_SCROLL_PADDING; },
/* harmony export */   "N4": function() { return /* binding */ EVENT_ON_POINTER_MOVE; },
/* harmony export */   "NH": function() { return /* binding */ VK_ARROW_RIGHT; },
/* harmony export */   "NZ": function() { return /* binding */ EVENT_ON_POINTER_DOWN; },
/* harmony export */   "Op": function() { return /* binding */ MODULE_NAVIGATION; },
/* harmony export */   "PU": function() { return /* binding */ VK_ESCAPE; },
/* harmony export */   "S2": function() { return /* binding */ EVENT_ON_POINTER_UP; },
/* harmony export */   "SA": function() { return /* binding */ MODULE_PORTAL; },
/* harmony export */   "Sl": function() { return /* binding */ VK_ARROW_LEFT; },
/* harmony export */   "Tf": function() { return /* binding */ CLASS_NO_SCROLL; },
/* harmony export */   "Vt": function() { return /* binding */ EVENT_ON_POINTER_CANCEL; },
/* harmony export */   "Xe": function() { return /* binding */ SLIDE_STATUS_LOADING; },
/* harmony export */   "Zv": function() { return /* binding */ SLIDE_STATUS_COMPLETE; },
/* harmony export */   "aN": function() { return /* binding */ CLASS_FLEX_CENTER; },
/* harmony export */   "bg": function() { return /* binding */ ELEMENT_BUTTON; },
/* harmony export */   "dA": function() { return /* binding */ PLUGIN_THUMBNAILS; },
/* harmony export */   "ds": function() { return /* binding */ EVENT_ON_KEY_DOWN; },
/* harmony export */   "fS": function() { return /* binding */ SLIDE_STATUS_ERROR; },
/* harmony export */   "hb": function() { return /* binding */ MODULE_TOOLBAR; },
/* harmony export */   "i4": function() { return /* binding */ MODULE_CORE; },
/* harmony export */   "j3": function() { return /* binding */ IMAGE_FIT_CONTAIN; },
/* harmony export */   "k0": function() { return /* binding */ MODULE_CAROUSEL; },
/* harmony export */   "l4": function() { return /* binding */ MODULE_CONTROLLER; },
/* harmony export */   "n2": function() { return /* binding */ YARL_EVENT_BACKDROP_CLICK; },
/* harmony export */   "pE": function() { return /* binding */ EVENT_ON_POINTER_LEAVE; },
/* harmony export */   "rO": function() { return /* binding */ IMAGE_FIT_COVER; },
/* harmony export */   "t9": function() { return /* binding */ ACTION_CLOSE; },
/* harmony export */   "vg": function() { return /* binding */ ELEMENT_ICON; },
/* harmony export */   "yS": function() { return /* binding */ CLASS_FULLSIZE; },
/* harmony export */   "yq": function() { return /* binding */ EVENT_ON_WHEEL; },
/* harmony export */   "zr": function() { return /* binding */ PLUGIN_FULLSCREEN; }
/* harmony export */ });
/* unused harmony exports PLUGIN_CAPTIONS, PLUGIN_INLINE, PLUGIN_SLIDESHOW, PLUGIN_ZOOM, SLIDE_STATUS_PLAYING, ACTIVE_SLIDE_LOADING, ACTIVE_SLIDE_PLAYING, ACTIVE_SLIDE_ERROR, ACTIVE_SLIDE_COMPLETE */
const MODULE_CAROUSEL = "carousel";
const MODULE_CONTROLLER = "controller";
const MODULE_CORE = "core";
const MODULE_NAVIGATION = "navigation";
const MODULE_NO_SCROLL = "no-scroll";
const MODULE_PORTAL = "portal";
const MODULE_TOOLBAR = "toolbar";
const PLUGIN_CAPTIONS = "captions";
const PLUGIN_FULLSCREEN = "fullscreen";
const PLUGIN_INLINE = "inline";
const PLUGIN_SLIDESHOW = "slideshow";
const PLUGIN_THUMBNAILS = "thumbnails";
const PLUGIN_ZOOM = "zoom";
const SLIDE_STATUS_LOADING = "loading";
const SLIDE_STATUS_PLAYING = "playing";
const SLIDE_STATUS_ERROR = "error";
const SLIDE_STATUS_COMPLETE = "complete";
const SLIDE_STATUS_PLACEHOLDER = "placeholder";
const activeSlideStatus = (status) => `active-slide-${status}`;
const ACTIVE_SLIDE_LOADING = activeSlideStatus(SLIDE_STATUS_LOADING);
const ACTIVE_SLIDE_PLAYING = activeSlideStatus(SLIDE_STATUS_PLAYING);
const ACTIVE_SLIDE_ERROR = activeSlideStatus(SLIDE_STATUS_ERROR);
const ACTIVE_SLIDE_COMPLETE = activeSlideStatus(SLIDE_STATUS_COMPLETE);
const YARL_EVENT_BACKDROP_CLICK = "backdrop_click";
const CLASS_FULLSIZE = "fullsize";
const CLASS_FLEX_CENTER = "flex_center";
const CLASS_NO_SCROLL = "no_scroll";
const CLASS_NO_SCROLL_PADDING = "no_scroll_padding";
const ACTION_PREV = "prev";
const ACTION_NEXT = "next";
const ACTION_CLOSE = "close";
const EVENT_ON_POINTER_DOWN = "onPointerDown";
const EVENT_ON_POINTER_MOVE = "onPointerMove";
const EVENT_ON_POINTER_UP = "onPointerUp";
const EVENT_ON_POINTER_LEAVE = "onPointerLeave";
const EVENT_ON_POINTER_CANCEL = "onPointerCancel";
const EVENT_ON_KEY_DOWN = "onKeyDown";
const EVENT_ON_KEY_UP = "onKeyUp";
const EVENT_ON_WHEEL = "onWheel";
const VK_ESCAPE = "Escape";
const VK_ARROW_LEFT = "ArrowLeft";
const VK_ARROW_RIGHT = "ArrowRight";
const ELEMENT_BUTTON = "button";
const ELEMENT_ICON = "icon";
const IMAGE_FIT_CONTAIN = "contain";
const IMAGE_FIT_COVER = "cover";


/***/ }),

/***/ 31390:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ EventsProvider; },
/* harmony export */   "h": function() { return /* binding */ useEvents; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45746);


const EventsContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const useEvents = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .makeUseContext */ .Fy)("useEvents", "EventsContext", EventsContext);
const EventsProvider = ({ children }) => {
    const [subscriptions] = react__WEBPACK_IMPORTED_MODULE_0__.useState({});
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => () => {
        Object.keys(subscriptions).forEach((key) => delete subscriptions[key]);
    }, [subscriptions]);
    const context = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
        const unsubscribe = (topic, callback) => {
            if (subscriptions[topic]) {
                subscriptions[topic] = subscriptions[topic].filter((cb) => cb !== callback);
            }
        };
        const subscribe = (topic, callback) => {
            if (!subscriptions[topic]) {
                subscriptions[topic] = [];
            }
            subscriptions[topic].push(callback);
            return () => unsubscribe(topic, callback);
        };
        const publish = (topic, event) => {
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 ? void 0 : _a.forEach((callback) => callback(event));
        };
        return { publish, subscribe, unsubscribe };
    }, [subscriptions]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(EventsContext.Provider, { value: context }, children);
};


/***/ }),

/***/ 12986:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useLightboxState; },
/* harmony export */   "q": function() { return /* binding */ LightboxStateProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45746);


const LightboxStateContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const useLightboxState = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .makeUseContext */ .Fy)("useLightboxState", "LightboxStateContext", LightboxStateContext);
const reducer = (slidesCount) => (state, action) => {
    var _a;
    return action.increment !== undefined || action.animationDuration !== undefined
        ? {
            currentIndex: (((state.currentIndex + (action.increment || 0)) % slidesCount) + slidesCount) % slidesCount,
            globalIndex: state.globalIndex + (action.increment || 0),
            animationDuration: (_a = action.animationDuration) !== null && _a !== void 0 ? _a : state.animationDuration,
        }
        : state;
};
const LightboxStateProvider = ({ initialIndex, slidesCount, children, }) => {
    const [state, dispatch] = react__WEBPACK_IMPORTED_MODULE_0__.useReducer(reducer(slidesCount), {
        currentIndex: initialIndex,
        globalIndex: initialIndex,
        animationDuration: 0,
    });
    const context = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({ state, dispatch }), [state, dispatch]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(LightboxStateContext.Provider, { value: context }, children);
};


/***/ }),

/***/ 4623:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useTimeouts; },
/* harmony export */   "q": function() { return /* binding */ TimeoutsProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45746);


const TimeoutsContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const useTimeouts = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .makeUseContext */ .Fy)("useTimeouts", "TimeoutsContext", TimeoutsContext);
const TimeoutsProvider = ({ children }) => {
    const [timeouts] = react__WEBPACK_IMPORTED_MODULE_0__.useState([]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => () => {
        timeouts.forEach((tid) => window.clearTimeout(tid));
        timeouts.splice(0, timeouts.length);
    }, [timeouts]);
    const context = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
        const removeTimeout = (id) => {
            timeouts.splice(0, timeouts.length, ...timeouts.filter((tid) => tid !== id));
        };
        const setTimeout = (fn, delay) => {
            const id = window.setTimeout(() => {
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        const clearTimeout = (id) => {
            if ((0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .isDefined */ .$K)(id)) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return { setTimeout, clearTimeout };
    }, [timeouts]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(TimeoutsContext.Provider, { value: context }, children);
};


/***/ }),

/***/ 24490:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useContainerRect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useContainerRect = () => {
    const [containerRect, setContainerRect] = react__WEBPACK_IMPORTED_MODULE_0__.useState();
    const containerRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    const observerRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const setContainerRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback((node) => {
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        const updateContainerRect = () => {
            if (node) {
                const styles = window.getComputedStyle(node);
                const parse = (value) => parseFloat(value) || 0;
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom)),
                });
            }
            else {
                setContainerRect(undefined);
            }
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
        setContainerRef,
        containerRef,
        containerRect,
    }), [setContainerRef, containerRef, containerRect]);
};


/***/ }),

/***/ 83744:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6269);


const useEventCallback = (fn) => {
    const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
    (0,_useLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(() => {
        ref.current = fn;
    });
    return react__WEBPACK_IMPORTED_MODULE_0__.useCallback((...args) => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args); }, []);
};


/***/ }),

/***/ 6269:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45746);


const useLayoutEffect = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .hasWindow */ .Ym)() ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


/***/ }),

/***/ 6404:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useMotionPreference; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useMotionPreference = () => {
    const [reduceMotion, setReduceMotion] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        var _a;
        const mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        const listener = () => setReduceMotion(mediaQuery.matches);
        mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener("change", listener);
        return () => mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener("change", listener);
    }, []);
    return reduceMotion;
};


/***/ }),

/***/ 81969:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useRTL; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6269);


const useRTL = () => {
    const [isRTL, setIsRTL] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
    (0,_useLayoutEffect_js__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(() => {
        setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
    }, []);
    return isRTL;
};


/***/ }),

/***/ 67228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "un": function() { return /* binding */ ControllerModule; },
  "bc": function() { return /* binding */ useController; }
});

// UNUSED EXPORTS: Controller

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/config.js
var config = __webpack_require__(36615);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/utils.js
var utils = __webpack_require__(45746);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/consts.js
var consts = __webpack_require__(97678);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useSensors.js


const useSensors = () => {
    const [subscribers] = react.useState({});
    return react.useMemo(() => {
        const notifySubscribers = (type, event) => {
            var _a;
            (_a = subscribers[type]) === null || _a === void 0 ? void 0 : _a.forEach((listener) => {
                if (!event.isPropagationStopped())
                    listener(event);
            });
        };
        return {
            registerSensors: {
                onPointerDown: (event) => notifySubscribers(consts/* EVENT_ON_POINTER_DOWN */.NZ, event),
                onPointerMove: (event) => notifySubscribers(consts/* EVENT_ON_POINTER_MOVE */.N4, event),
                onPointerUp: (event) => notifySubscribers(consts/* EVENT_ON_POINTER_UP */.S2, event),
                onPointerLeave: (event) => notifySubscribers(consts/* EVENT_ON_POINTER_LEAVE */.pE, event),
                onPointerCancel: (event) => notifySubscribers(consts/* EVENT_ON_POINTER_CANCEL */.Vt, event),
                onKeyDown: (event) => notifySubscribers(consts/* EVENT_ON_KEY_DOWN */.ds, event),
                onKeyUp: (event) => notifySubscribers(consts/* EVENT_ON_KEY_UP */.Bm, event),
                onWheel: (event) => notifySubscribers(consts/* EVENT_ON_WHEEL */.yq, event),
            },
            subscribeSensors: (type, callback) => {
                if (!subscribers[type]) {
                    subscribers[type] = [];
                }
                subscribers[type].unshift(callback);
                return () => {
                    const listeners = subscribers[type];
                    if (listeners) {
                        listeners.splice(0, listeners.length, ...listeners.filter((el) => el !== callback));
                    }
                };
            },
        };
    }, [subscribers]);
};

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useContainerRect.js
var useContainerRect = __webpack_require__(24490);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useForkRef.js

const setRef = (ref, value) => {
    if (typeof ref === "function") {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
};
const useForkRef = (refA, refB) => react.useMemo(() => refA == null && refB == null
    ? null
    : (refValue) => {
        setRef(refA, refValue);
        setRef(refB, refValue);
    }, [refA, refB]);

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useMotionPreference.js
var useMotionPreference = __webpack_require__(6404);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useRTL.js
var useRTL = __webpack_require__(81969);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useEventCallback.js
var useEventCallback = __webpack_require__(83744);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(6269);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/LightboxState.js
var LightboxState = __webpack_require__(12986);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/Events.js
var Events = __webpack_require__(31390);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/Timeouts.js
var Timeouts = __webpack_require__(4623);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/controller/index.js
var SwipeState;
(function (SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["ANIMATION"] = 2] = "ANIMATION";
})(SwipeState || (SwipeState = {}));




;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/controller/usePreventSwipeNavigation.js

const WHEEL = "wheel";
const preventDefault = (event) => {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.ctrlKey) {
        event.preventDefault();
    }
};
const usePreventSwipeNavigation = () => {
    const ref = react.useRef(null);
    return react.useCallback((node) => {
        var _a;
        if (node) {
            node.addEventListener(WHEEL, preventDefault, { passive: false });
        }
        else {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener(WHEEL, preventDefault);
        }
        ref.current = node;
    }, []);
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/controller/usePointerSwipe.js




const usePointerSwipe = (subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) => {
    const offset = react.useRef(0);
    const pointers = react.useRef([]);
    const activePointer = react.useRef();
    const startTime = react.useRef(0);
    const clearPointer = react.useCallback((event) => {
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
        }
        const currentPointers = pointers.current;
        currentPointers.splice(0, currentPointers.length, ...currentPointers.filter((p) => p.pointerId !== event.pointerId));
    }, []);
    const addPointer = react.useCallback((event) => {
        clearPointer(event);
        pointers.current.push(event);
    }, [clearPointer]);
    const onPointerDown = (0,useEventCallback/* useEventCallback */.$)((event) => {
        addPointer(event);
    });
    const onPointerUp = (0,useEventCallback/* useEventCallback */.$)((event) => {
        if (pointers.current.find((x) => x.pointerId === event.pointerId) &&
            activePointer.current === event.pointerId) {
            const duration = Date.now() - startTime.current;
            const currentOffset = offset.current;
            if (Math.abs(currentOffset) > 0.3 * containerWidth ||
                (Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration)) {
                onSwipeFinish(currentOffset, duration);
            }
            else {
                onSwipeCancel(currentOffset);
            }
            offset.current = 0;
        }
        clearPointer(event);
    });
    const onPointerMove = (0,useEventCallback/* useEventCallback */.$)((event) => {
        const pointer = pointers.current.find((p) => p.pointerId === event.pointerId);
        if (pointer) {
            const deltaX = event.clientX - pointer.clientX;
            const deltaY = event.clientY - pointer.clientY;
            if (!activePointer.current &&
                isSwipeValid(deltaX) &&
                Math.abs(deltaX) > Math.abs(deltaY) &&
                Math.abs(deltaX) > 30) {
                addPointer(event);
                activePointer.current = event.pointerId;
                startTime.current = Date.now();
                onSwipeStart();
            }
            else if (activePointer.current === event.pointerId) {
                offset.current = deltaX;
                onSwipeProgress(deltaX);
            }
        }
    });
    react.useEffect(() => (0,utils/* cleanup */.Eq)(subscribeSensors(consts/* EVENT_ON_POINTER_DOWN */.NZ, onPointerDown), subscribeSensors(consts/* EVENT_ON_POINTER_MOVE */.N4, onPointerMove), subscribeSensors(consts/* EVENT_ON_POINTER_UP */.S2, onPointerUp), subscribeSensors(consts/* EVENT_ON_POINTER_LEAVE */.pE, onPointerUp), subscribeSensors(consts/* EVENT_ON_POINTER_CANCEL */.Vt, onPointerUp)), [subscribeSensors, onPointerDown, onPointerMove, onPointerUp]);
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/controller/useWheelSwipe.js





const useWheelSwipe = (swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) => {
    const offset = react.useRef(0);
    const intent = react.useRef(0);
    const intentCleanup = react.useRef();
    const resetCleanup = react.useRef();
    const wheelResidualMomentum = react.useRef(0);
    const startTime = react.useRef(0);
    const { setTimeout, clearTimeout } = (0,Timeouts/* useTimeouts */.a)();
    const cancelSwipeIntentCleanup = react.useCallback(() => {
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [clearTimeout]);
    const cancelSwipeResetCleanup = react.useCallback(() => {
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [clearTimeout]);
    const handleCleanup = (0,useEventCallback/* useEventCallback */.$)(() => {
        if (swipeState !== SwipeState.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    react.useEffect(handleCleanup, [swipeState, handleCleanup]);
    const handleCancelSwipe = (0,useEventCallback/* useEventCallback */.$)((currentSwipeOffset) => {
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) {
            onSwipeCancel(offset.current);
        }
    });
    const onWheel = (0,useEventCallback/* useEventCallback */.$)((event) => {
        if (event.ctrlKey) {
            return;
        }
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            return;
        }
        if (!swipeState) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelResidualMomentum.current)) {
                wheelResidualMomentum.current = event.deltaX;
                return;
            }
            if (!isSwipeValid(-event.deltaX)) {
                return;
            }
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                wheelResidualMomentum.current = 0;
                startTime.current = Date.now();
                onSwipeStart();
            }
            else {
                const currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(() => {
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) {
                        intent.current = 0;
                    }
                }, swipeAnimationDuration);
            }
        }
        else if (swipeState === SwipeState.SWIPE) {
            let newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                wheelResidualMomentum.current = event.deltaX;
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(() => handleCancelSwipe(newSwipeOffset), 2 * swipeAnimationDuration);
        }
        else {
            wheelResidualMomentum.current = event.deltaX;
        }
    });
    react.useEffect(() => subscribeSensors(consts/* EVENT_ON_WHEEL */.yq, onWheel), [subscribeSensors, onWheel]);
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/Controller.js







const cssContainerPrefix = (0,utils/* makeComposePrefix */.cO)("container");
const ControllerContext = react.createContext(null);
const useController = (0,utils/* makeUseContext */.Fy)("useController", "ControllerContext", ControllerContext);
const Controller = ({ children, ...props }) => {
    const { carousel, slides, animation, controller, on, styles } = props;
    const { state, dispatch } = (0,LightboxState/* useLightboxState */.o)();
    const [swipeState, setSwipeState] = react.useState(SwipeState.NONE);
    const swipeOffset = react.useRef(0);
    const swipeAnimationReset = react.useRef();
    const { registerSensors, subscribeSensors } = useSensors();
    const { subscribe, publish } = (0,Events/* useEvents */.h)();
    const { setTimeout, clearTimeout } = (0,Timeouts/* useTimeouts */.a)();
    const { containerRef, setContainerRef, containerRect } = (0,useContainerRect/* useContainerRect */.u)();
    const handleContainerRef = useForkRef(usePreventSwipeNavigation(), setContainerRef);
    const carouselRef = react.useRef(null);
    const setCarouselRef = useForkRef(carouselRef, undefined);
    const carouselAnimation = react.useRef();
    const carouselSwipeAnimation = react.useRef();
    const reduceMotion = (0,useMotionPreference/* useMotionPreference */.O)();
    const isRTL = (0,useRTL/* useRTL */.S)();
    const rtl = (0,useEventCallback/* useEventCallback */.$)((value) => (isRTL ? -1 : 1) * ((0,utils/* isNumber */.hj)(value) ? value : 1));
    const isSwipeValid = (0,useEventCallback/* useEventCallback */.$)((offset) => !(carousel.finite &&
        ((rtl(offset) > 0 && state.currentIndex === 0) ||
            (rtl(offset) < 0 && state.currentIndex === slides.length - 1))));
    const setSwipeOffset = react.useCallback((offset) => {
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty((0,utils/* cssVar */.gJ)("swipe_offset"), `${Math.round(offset)}px`);
    }, [containerRef]);
    const swipe = (0,useEventCallback/* useEventCallback */.$)((action) => {
        var _a;
        const swipeDuration = animation.swipe;
        const currentSwipeOffset = action.offset || 0;
        let { direction } = action;
        const count = (_a = action.count) !== null && _a !== void 0 ? _a : 1;
        let newSwipeState = SwipeState.ANIMATION;
        let newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            const containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            const elapsedTime = action.duration || 0;
            const expectedTime = containerWidth
                ? (swipeDuration / containerWidth) * Math.abs(currentSwipeOffset)
                : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) {
                    newSwipeAnimationDuration =
                        (newSwipeAnimationDuration / expectedTime) * Math.max(elapsedTime, expectedTime / 5);
                }
                else if (containerWidth) {
                    newSwipeAnimationDuration =
                        (swipeDuration / containerWidth) * (containerWidth - Math.abs(currentSwipeOffset));
                }
            }
            else {
                newSwipeAnimationDuration = swipeDuration / 2;
            }
            if (count !== 0) {
                direction = rtl(currentSwipeOffset) > 0 ? consts/* ACTION_PREV */.KN : consts/* ACTION_NEXT */.Eb;
            }
        }
        let increment;
        if (direction === consts/* ACTION_PREV */.KN) {
            if (isSwipeValid(rtl(1))) {
                increment = -count;
            }
            else {
                newSwipeState = SwipeState.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        else if (direction === consts/* ACTION_NEXT */.Eb) {
            if (isSwipeValid(rtl(-1))) {
                increment = count;
            }
            else {
                newSwipeState = SwipeState.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        if (carouselRef.current) {
            carouselSwipeAnimation.current = {
                rect: carouselRef.current.getBoundingClientRect(),
                index: state.globalIndex,
            };
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        clearTimeout(swipeAnimationReset.current);
        if (newSwipeState) {
            const timeoutId = setTimeout(() => {
                if (swipeAnimationReset.current === timeoutId) {
                    setSwipeOffset(0);
                    setSwipeState(SwipeState.NONE);
                }
            }, newSwipeAnimationDuration);
            swipeAnimationReset.current = timeoutId;
        }
        setSwipeState(newSwipeState);
        dispatch({ increment, animationDuration: newSwipeAnimationDuration });
    });
    const animateCarouselSwipe = (0,useEventCallback/* useEventCallback */.$)(() => {
        var _a, _b, _c;
        const swipeAnimation = carouselSwipeAnimation.current;
        carouselSwipeAnimation.current = undefined;
        if (swipeAnimation && carouselRef.current && containerRect) {
            const parsedSpacing = (0,utils/* parseLengthPercentage */.Ay)(carousel.spacing);
            const spacingValue = (parsedSpacing.percent ? (parsedSpacing.percent * containerRect.width) / 100 : parsedSpacing.pixel) ||
                0;
            (_a = carouselAnimation.current) === null || _a === void 0 ? void 0 : _a.cancel();
            carouselAnimation.current = (_c = (_b = carouselRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, [
                {
                    transform: `translateX(${rtl(state.globalIndex - swipeAnimation.index) * (containerRect.width + spacingValue) +
                        swipeAnimation.rect.x -
                        carouselRef.current.getBoundingClientRect().x}px)`,
                },
                { transform: "translateX(0)" },
            ], !reduceMotion ? state.animationDuration : 0);
            if (carouselAnimation.current) {
                carouselAnimation.current.onfinish = () => {
                    carouselAnimation.current = undefined;
                };
            }
        }
    });
    (0,useLayoutEffect/* useLayoutEffect */.b)(animateCarouselSwipe);
    const swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        () => setSwipeState(SwipeState.SWIPE),
        (offset) => setSwipeOffset(offset),
        (offset, duration) => swipe({ offset, duration, count: 1 }),
        (offset) => swipe({ offset, count: 0 }),
    ];
    usePointerSwipe(...swipeParams);
    useWheelSwipe(swipeState, ...swipeParams);
    const focusOnMount = (0,useEventCallback/* useEventCallback */.$)(() => {
        var _a;
        if (controller.focus) {
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    });
    react.useEffect(focusOnMount, [focusOnMount]);
    const handleIndexChange = (0,useEventCallback/* useEventCallback */.$)(() => {
        var _a;
        (_a = on.view) === null || _a === void 0 ? void 0 : _a.call(on, state.currentIndex);
    });
    react.useEffect(handleIndexChange, [state.currentIndex, handleIndexChange]);
    react.useEffect(() => (0,utils/* cleanup */.Eq)(subscribe(consts/* ACTION_PREV */.KN, (count) => swipe({
        direction: consts/* ACTION_PREV */.KN,
        count: (0,utils/* isNumber */.hj)(count) ? count : undefined,
    })), subscribe(consts/* ACTION_NEXT */.Eb, (count) => swipe({
        direction: consts/* ACTION_NEXT */.Eb,
        count: (0,utils/* isNumber */.hj)(count) ? count : undefined,
    }))), [subscribe, swipe]);
    react.useEffect(() => subscribeSensors(consts/* EVENT_ON_KEY_UP */.Bm, (event) => {
        if (event.code === consts/* VK_ESCAPE */.PU) {
            publish(consts/* ACTION_CLOSE */.t9);
        }
    }), [subscribeSensors, publish]);
    react.useEffect(() => controller.closeOnBackdropClick
        ? subscribe(consts/* YARL_EVENT_BACKDROP_CLICK */.n2, () => publish(consts/* ACTION_CLOSE */.t9))
        : () => { }, [controller.closeOnBackdropClick, publish, subscribe]);
    const transferFocus = (0,useEventCallback/* useEventCallback */.$)(() => { var _a; return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
    const getLightboxProps = (0,useEventCallback/* useEventCallback */.$)(() => props);
    const context = react.useMemo(() => ({
        getLightboxProps,
        subscribeSensors,
        transferFocus,
        containerRect: containerRect || { width: 0, height: 0 },
        containerRef,
        setCarouselRef,
    }), [getLightboxProps, subscribeSensors, transferFocus, containerRect, containerRef, setCarouselRef]);
    return (react.createElement("div", { ref: handleContainerRef, className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(cssContainerPrefix()), (0,utils/* cssClass */.Nc)(consts/* CLASS_FLEX_CENTER */.aN)), style: {
            ...(swipeState === SwipeState.SWIPE
                ? { [(0,utils/* cssVar */.gJ)("swipe_offset")]: `${Math.round(swipeOffset.current)}px` }
                : null),
            ...(controller.touchAction !== "none" ? {} : null),
            ...styles.container,
        }, ...(controller.aria ? { role: "presentation", "aria-live": "polite" } : null), tabIndex: -1, ...registerSensors }, containerRect && react.createElement(ControllerContext.Provider, { value: context }, children)));
};
const ControllerModule = (0,config/* createModule */.l6)(consts/* MODULE_CONTROLLER */.l4, Controller);


/***/ }),

/***/ 45746:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ isDefined; },
/* harmony export */   "Ay": function() { return /* binding */ parseLengthPercentage; },
/* harmony export */   "Eq": function() { return /* binding */ cleanup; },
/* harmony export */   "Fy": function() { return /* binding */ makeUseContext; },
/* harmony export */   "Nc": function() { return /* binding */ cssClass; },
/* harmony export */   "PS": function() { return /* binding */ label; },
/* harmony export */   "QB": function() { return /* binding */ isImageSlide; },
/* harmony export */   "Wy": function() { return /* binding */ clsx; },
/* harmony export */   "Xl": function() { return /* binding */ composePrefix; },
/* harmony export */   "Ym": function() { return /* binding */ hasWindow; },
/* harmony export */   "cO": function() { return /* binding */ makeComposePrefix; },
/* harmony export */   "gJ": function() { return /* binding */ cssVar; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; }
/* harmony export */ });
/* unused harmony exports round, devicePixelRatio */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const clsx = (...classes) => [...classes].filter((cls) => Boolean(cls)).join(" ");
const cssPrefix = "yarl__";
const cssClass = (name) => `${cssPrefix}${name}`;
const cssVar = (name) => `--${cssPrefix}${name}`;
const composePrefix = (base, prefix) => `${base}${prefix ? `_${prefix}` : ""}`;
const makeComposePrefix = (base) => (prefix) => composePrefix(base, prefix);
const label = (labels, lbl) => (labels && labels[lbl] ? labels[lbl] : lbl);
const cleanup = (...cleaners) => () => {
    cleaners.forEach((cleaner) => {
        cleaner();
    });
};
const makeUseContext = (name, contextName, context) => () => {
    const ctx = react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
    if (!ctx) {
        throw new Error(`${name} must be used within a ${contextName}.Provider`);
    }
    return ctx;
};
const hasWindow = () => typeof window !== "undefined";
const isDefined = (x) => typeof x !== "undefined";
const isNumber = (value) => typeof value === "number";
const round = (value, decimals = 0) => {
    const factor = 10 ** decimals;
    return Math.round((value + Number.EPSILON) * factor) / factor;
};
const isImageSlide = (slide) => !isDefined(slide.type) || slide.type === "image";
const parseLengthPercentage = (input) => {
    if (typeof input === "number") {
        return { pixel: input };
    }
    if (typeof input === "string") {
        const value = parseInt(input, 10);
        return input.endsWith("%") ? { percent: value } : { pixel: value };
    }
    return { pixel: 0 };
};
const devicePixelRatio = () => {
    return (typeof window !== "undefined" ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
};


/***/ }),

/***/ 71227:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dist; }
});

// UNUSED EXPORTS: Lightbox

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/consts.js
var consts = __webpack_require__(97678);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/props.js

const LightboxDefaultProps = {
    open: false,
    close: () => { },
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: { buttons: [consts/* ACTION_CLOSE */.t9] },
    labels: {},
    animation: {
        fade: 330,
        swipe: 500,
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: consts/* IMAGE_FIT_CONTAIN */.j3,
    },
    controller: {
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnBackdropClick: false,
    },
    on: {},
    styles: {},
    className: "",
};

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/config.js
var core_config = __webpack_require__(36615);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/utils.js
var utils = __webpack_require__(45746);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useMotionPreference.js
var useMotionPreference = __webpack_require__(6404);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useEventCallback.js
var useEventCallback = __webpack_require__(83744);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/Timeouts.js
var Timeouts = __webpack_require__(4623);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/Events.js
var Events = __webpack_require__(31390);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/Portal.js








const cssPrefix = (value) => (0,utils/* composePrefix */.Xl)(consts/* MODULE_PORTAL */.SA, value);
const setAttribute = (element, attribute, value) => {
    const previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return () => {
        if (previousValue) {
            element.setAttribute(attribute, previousValue);
        }
        else {
            element.removeAttribute(attribute);
        }
    };
};
const Portal = ({ children, animation, styles, className, on, close }) => {
    const [mounted, setMounted] = react.useState(false);
    const [visible, setVisible] = react.useState(false);
    const cleanup = react.useRef([]);
    const { setTimeout } = (0,Timeouts/* useTimeouts */.a)();
    const { subscribe } = (0,Events/* useEvents */.h)();
    const fadeAnimationDuration = !(0,useMotionPreference/* useMotionPreference */.O)() ? animation.fade : 0;
    react.useEffect(() => {
        setMounted(true);
        return () => {
            setMounted(false);
            setVisible(false);
        };
    }, []);
    const handleClose = (0,useEventCallback/* useEventCallback */.$)(() => {
        var _a;
        setVisible(false);
        (_a = on.exiting) === null || _a === void 0 ? void 0 : _a.call(on);
        setTimeout(() => {
            var _a;
            (_a = on.exited) === null || _a === void 0 ? void 0 : _a.call(on);
            close();
        }, fadeAnimationDuration);
    });
    react.useEffect(() => subscribe(consts/* ACTION_CLOSE */.t9, handleClose), [subscribe, handleClose]);
    const handleEnter = (0,useEventCallback/* useEventCallback */.$)((node) => {
        var _a, _b, _c;
        node.scrollTop;
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 ? void 0 : _a.call(on);
        const elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for (let i = 0; i < elements.length; i += 1) {
            const element = elements[i];
            if (["TEMPLATE", "SCRIPT", "STYLE"].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push(setAttribute(element, "inert", "true"));
                cleanup.current.push(setAttribute(element, "aria-hidden", "true"));
            }
        }
        setTimeout(() => {
            var _a;
            (_a = on.entered) === null || _a === void 0 ? void 0 : _a.call(on);
        }, fadeAnimationDuration);
    });
    const handleExit = (0,useEventCallback/* useEventCallback */.$)(() => {
        cleanup.current.forEach((clean) => clean());
        cleanup.current = [];
    });
    const handleRef = react.useCallback((node) => {
        if (node) {
            handleEnter(node);
        }
        else {
            handleExit();
        }
    }, [handleEnter, handleExit]);
    return mounted
        ? react_dom.createPortal(react.createElement("div", { ref: handleRef, className: (0,utils/* clsx */.Wy)(className, (0,utils/* cssClass */.Nc)("root"), (0,utils/* cssClass */.Nc)(cssPrefix()), (0,utils/* cssClass */.Nc)(consts/* CLASS_NO_SCROLL_PADDING */.M9), visible && (0,utils/* cssClass */.Nc)(cssPrefix("open"))), role: "presentation", "aria-live": "polite", style: {
                ...(animation.fade !== LightboxDefaultProps.animation.fade
                    ? {
                        [(0,utils/* cssVar */.gJ)("fade_animation_duration")]: `${fadeAnimationDuration}ms`,
                    }
                    : null),
                ...styles.root,
            } }, children), document.body)
        : null;
};
const PortalModule = (0,core_config/* createModule */.l6)(consts/* MODULE_PORTAL */.SA, Portal);

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useRTL.js
var useRTL = __webpack_require__(81969);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(6269);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/NoScroll.js





const noScroll = (0,utils/* cssClass */.Nc)(consts/* CLASS_NO_SCROLL */.Tf);
const noScrollPadding = (0,utils/* cssClass */.Nc)(consts/* CLASS_NO_SCROLL_PADDING */.M9);
const isHTMLElement = (element) => "style" in element;
const padScrollbar = (element, padding, rtl) => {
    const styles = window.getComputedStyle(element);
    const property = rtl ? "padding-left" : "padding-right";
    const computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    const originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, `${(parseInt(computedValue, 10) || 0) + padding}px`);
    return () => {
        if (originalValue) {
            element.style.setProperty(property, originalValue);
        }
        else {
            element.style.removeProperty(property);
        }
    };
};
const NoScroll = ({ children }) => {
    const rtl = (0,useRTL/* useRTL */.S)();
    (0,useLayoutEffect/* useLayoutEffect */.b)(() => {
        const cleanup = [];
        const { body, documentElement } = document;
        const scrollbar = Math.round(window.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push(padScrollbar(body, scrollbar, rtl));
            const elements = body.getElementsByTagName("*");
            for (let i = 0; i < elements.length; i += 1) {
                const element = elements[i];
                if (isHTMLElement(element) &&
                    window.getComputedStyle(element).getPropertyValue("position") === "fixed" &&
                    !element.classList.contains(noScrollPadding)) {
                    cleanup.push(padScrollbar(element, scrollbar, rtl));
                }
            }
        }
        body.classList.add(noScroll);
        return () => {
            body.classList.remove(noScroll);
            cleanup.forEach((clean) => clean());
        };
    }, [rtl]);
    return react.createElement(react.Fragment, null, children);
};
const NoScrollModule = (0,core_config/* createModule */.l6)(consts/* MODULE_NO_SCROLL */.HE, NoScroll);

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/Controller.js + 6 modules
var Controller = __webpack_require__(67228);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useContainerRect.js
var useContainerRect = __webpack_require__(24490);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/components/ImageSlide.js
var ImageSlide = __webpack_require__(18733);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/LightboxState.js
var LightboxState = __webpack_require__(12986);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/Carousel.js









const Carousel_cssPrefix = (value) => (0,utils/* composePrefix */.Xl)(consts/* MODULE_CAROUSEL */.k0, value);
const cssSlidePrefix = (value) => (0,utils/* composePrefix */.Xl)("slide", value);
const CarouselSlide = ({ slide, offset }) => {
    const { setContainerRef, containerRect, containerRef } = (0,useContainerRect/* useContainerRect */.u)();
    const { publish } = (0,Events/* useEvents */.h)();
    const { state: { currentIndex }, } = (0,LightboxState/* useLightboxState */.o)();
    const { getLightboxProps } = (0,Controller/* useController */.bc)();
    const { render, carousel: { imageFit }, on: { click: onClick }, } = getLightboxProps();
    const renderSlide = (rect) => {
        var _a, _b, _c, _d;
        let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, slide, offset, rect);
        if (!rendered && (0,utils/* isImageSlide */.QB)(slide)) {
            rendered = (react.createElement(ImageSlide/* ImageSlide */.P, { slide: slide, offset: offset, render: render, rect: rect, imageFit: imageFit, onClick: offset === 0 ? () => onClick === null || onClick === void 0 ? void 0 : onClick(currentIndex) : undefined }));
        }
        return rendered ? (react.createElement(react.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 :
            _b.call(render, slide),
            ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : ((_, x) => x))(slide, rendered), (_d = render.slideFooter) === null || _d === void 0 ? void 0 :
            _d.call(render, slide))) : null;
    };
    const handleBackdropClick = (event) => {
        const container = containerRef.current;
        const target = event.target instanceof HTMLElement ? event.target : undefined;
        if (target &&
            container &&
            (target === container ||
                (Array.from(container.children).find((x) => x === target) &&
                    target.classList.contains((0,utils/* cssClass */.Nc)(consts/* CLASS_FULLSIZE */.yS))))) {
            publish(consts/* YARL_EVENT_BACKDROP_CLICK */.n2);
        }
    };
    return (react.createElement("div", { ref: setContainerRef, className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(cssSlidePrefix()), offset === 0 && (0,utils/* cssClass */.Nc)(cssSlidePrefix("current")), (0,utils/* cssClass */.Nc)(consts/* CLASS_FLEX_CENTER */.aN)), onClick: handleBackdropClick }, containerRect && renderSlide(containerRect)));
};
const Placeholder = () => react.createElement("div", { className: (0,utils/* cssClass */.Nc)("slide") });
const Carousel = ({ slides, carousel: { finite, preload, padding, spacing } }) => {
    const { state: { currentIndex, globalIndex }, } = (0,LightboxState/* useLightboxState */.o)();
    const { setCarouselRef } = (0,Controller/* useController */.bc)();
    const spacingValue = (0,utils/* parseLengthPercentage */.Ay)(spacing);
    const paddingValue = (0,utils/* parseLengthPercentage */.Ay)(padding);
    const items = [];
    if ((slides === null || slides === void 0 ? void 0 : slides.length) > 0) {
        for (let i = currentIndex - preload; i < currentIndex; i += 1) {
            const key = globalIndex + i - currentIndex;
            items.push(!finite || i >= 0 ? (react.createElement(CarouselSlide, { key: key, slide: slides[(i + preload * slides.length) % slides.length], offset: i - currentIndex })) : (react.createElement(Placeholder, { key: key })));
        }
        items.push(react.createElement(CarouselSlide, { key: globalIndex, slide: slides[currentIndex], offset: 0 }));
        for (let i = currentIndex + 1; i <= currentIndex + preload; i += 1) {
            const key = globalIndex + i - currentIndex;
            items.push(!finite || i <= slides.length - 1 ? (react.createElement(CarouselSlide, { key: key, slide: slides[i % slides.length], offset: i - currentIndex })) : (react.createElement(Placeholder, { key: key })));
        }
    }
    return (react.createElement("div", { ref: setCarouselRef, className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(Carousel_cssPrefix()), items.length > 0 && (0,utils/* cssClass */.Nc)(Carousel_cssPrefix("with_slides"))), style: {
            [`${(0,utils/* cssVar */.gJ)(Carousel_cssPrefix("slides_count"))}`]: items.length,
            [`${(0,utils/* cssVar */.gJ)(Carousel_cssPrefix("spacing_px"))}`]: spacingValue.pixel || 0,
            [`${(0,utils/* cssVar */.gJ)(Carousel_cssPrefix("spacing_percent"))}`]: spacingValue.percent || 0,
            [`${(0,utils/* cssVar */.gJ)(Carousel_cssPrefix("padding_px"))}`]: paddingValue.pixel || 0,
            [`${(0,utils/* cssVar */.gJ)(Carousel_cssPrefix("padding_percent"))}`]: paddingValue.percent || 0,
        } }, items));
};
const CarouselModule = (0,core_config/* createModule */.l6)(consts/* MODULE_CAROUSEL */.k0, Carousel);

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/components/IconButton.js
var IconButton = __webpack_require__(48645);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/components/Icons.js
var Icons = __webpack_require__(26668);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/Toolbar.js







const Toolbar_cssPrefix = (value) => (0,utils/* composePrefix */.Xl)(consts/* MODULE_TOOLBAR */.hb, value);
const Toolbar = ({ toolbar: { buttons }, labels, render: { buttonClose, iconClose } }) => {
    const { publish } = (0,Events/* useEvents */.h)();
    const { setContainerRef, containerRect } = (0,useContainerRect/* useContainerRect */.u)();
    react.useEffect(() => {
        if (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) {
            publish("toolbar-width", containerRect.width);
        }
    }, [publish, containerRect === null || containerRect === void 0 ? void 0 : containerRect.width]);
    const renderCloseButton = () => buttonClose ? (buttonClose()) : (react.createElement(IconButton/* IconButton */.h, { key: consts/* ACTION_CLOSE */.t9, label: (0,utils/* label */.PS)(labels, "Close"), icon: Icons/* CloseIcon */.Tw, renderIcon: iconClose, onClick: () => publish(consts/* ACTION_CLOSE */.t9) }));
    return (react.createElement("div", { ref: setContainerRef, className: (0,utils/* cssClass */.Nc)(Toolbar_cssPrefix()) }, buttons === null || buttons === void 0 ? void 0 : buttons.map((button) => (button === consts/* ACTION_CLOSE */.t9 ? renderCloseButton() : button))));
};
const ToolbarModule = (0,core_config/* createModule */.l6)(consts/* MODULE_TOOLBAR */.hb, Toolbar);

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/Navigation.js








const NavigationButton = ({ publish, labels, label, icon, renderIcon, action, disabled, }) => (react.createElement(IconButton/* IconButton */.h, { label: (0,utils/* label */.PS)(labels, label), icon: icon, renderIcon: renderIcon, className: (0,utils/* cssClass */.Nc)(`navigation_${action}`), disabled: disabled, "aria-disabled": disabled, onClick: () => {
        publish(action);
    } }));
const Navigation = ({ slides, carousel: { finite }, labels, render: { buttonPrev, buttonNext, iconPrev, iconNext }, }) => {
    const { state: { currentIndex }, } = (0,LightboxState/* useLightboxState */.o)();
    const { subscribeSensors } = (0,Controller/* useController */.bc)();
    const { publish } = (0,Events/* useEvents */.h)();
    const isRTL = (0,useRTL/* useRTL */.S)();
    const handleKeyDown = (0,useEventCallback/* useEventCallback */.$)((event) => {
        if (event.key === consts/* VK_ARROW_LEFT */.Sl) {
            publish(isRTL ? consts/* ACTION_NEXT */.Eb : consts/* ACTION_PREV */.KN);
        }
        else if (event.key === consts/* VK_ARROW_RIGHT */.NH) {
            publish(isRTL ? consts/* ACTION_PREV */.KN : consts/* ACTION_NEXT */.Eb);
        }
    });
    react.useEffect(() => subscribeSensors(consts/* EVENT_ON_KEY_DOWN */.ds, handleKeyDown), [subscribeSensors, handleKeyDown]);
    return (react.createElement(react.Fragment, null,
        buttonPrev ? (buttonPrev()) : (react.createElement(NavigationButton, { label: "Previous", action: consts/* ACTION_PREV */.KN, icon: Icons/* PreviousIcon */.jJ, renderIcon: iconPrev, disabled: slides.length === 0 || (finite && currentIndex === 0), labels: labels, publish: publish })),
        buttonNext ? (buttonNext()) : (react.createElement(NavigationButton, { label: "Next", action: consts/* ACTION_NEXT */.Eb, icon: Icons/* NextIcon */.Ne, renderIcon: iconNext, disabled: slides.length === 0 || (finite && currentIndex === slides.length - 1), labels: labels, publish: publish }))));
};
const NavigationModule = (0,core_config/* createModule */.l6)(consts/* MODULE_NAVIGATION */.Op, Navigation);

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/core/modules/Core.js




const Core = ({ slides, index, children }) => (react.createElement(Timeouts/* TimeoutsProvider */.q, null,
    react.createElement(Events/* EventsProvider */.Y, null,
        react.createElement(LightboxState/* LightboxStateProvider */.q, { slidesCount: slides.length, initialIndex: index }, children))));
const CoreModule = (0,core_config/* createModule */.l6)(consts/* MODULE_CORE */.i4, Core);

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/Lightbox.js



const renderNode = (node, props) => {
    var _a;
    return react.createElement(node.module.component, { key: node.module.name, ...props }, (_a = node.children) === null || _a === void 0 ? void 0 : _a.map((child) => renderNode(child, props)));
};
const Lightbox = (props) => {
    const { carousel, animation, render, toolbar, controller, on, plugins, ...restProps } = props;
    const { carousel: defaultCarousel, animation: defaultAnimation, render: defaultRender, toolbar: defaultToolbar, controller: defaultController, on: defaultOn, ...restDefaultProps } = LightboxDefaultProps;
    const { config, augmentation } = (0,core_config/* withPlugins */.AB)([
        (0,core_config/* createNode */.dS)(PortalModule, [
            (0,core_config/* createNode */.dS)(NoScrollModule, [
                (0,core_config/* createNode */.dS)(Controller/* ControllerModule */.un, [
                    (0,core_config/* createNode */.dS)(CarouselModule),
                    (0,core_config/* createNode */.dS)(ToolbarModule),
                    (0,core_config/* createNode */.dS)(NavigationModule),
                ]),
            ]),
        ]),
    ], plugins);
    const augmentedProps = augmentation({
        carousel: { ...defaultCarousel, ...carousel },
        animation: { ...defaultAnimation, ...animation },
        render: { ...defaultRender, ...render },
        toolbar: { ...defaultToolbar, ...toolbar },
        controller: { ...defaultController, ...controller },
        on: { ...defaultOn, ...on },
        ...restDefaultProps,
        ...restProps,
    });
    if (!augmentedProps.open)
        return null;
    return react.createElement(react.Fragment, null, renderNode((0,core_config/* createNode */.dS)(CoreModule, config), augmentedProps));
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/index.js



/* harmony default export */ var dist = (Lightbox);


/***/ }),

/***/ 69178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ fullscreen; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/consts.js
var consts = __webpack_require__(97678);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/config.js
var config = __webpack_require__(36615);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/components/Icons.js
var Icons = __webpack_require__(26668);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useEventCallback.js
var useEventCallback = __webpack_require__(83744);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/components/IconButton.js
var IconButton = __webpack_require__(48645);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/utils.js
var utils = __webpack_require__(45746);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/fullscreen/FullscreenContext.js


const FullscreenContext = react.createContext(null);
const useFullscreen = (0,utils/* makeUseContext */.Fy)("useFullscreen", "FullscreenContext", FullscreenContext);
const FullscreenContextProvider = ({ children }) => {
    const containerRef = react.useRef(null);
    return (react.createElement("div", { ref: containerRef, className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(consts/* PLUGIN_FULLSCREEN */.zr), (0,utils/* cssClass */.Nc)(consts/* CLASS_FULLSIZE */.yS)) },
        react.createElement(FullscreenContext.Provider, { value: containerRef }, children)));
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/fullscreen/FullscreenButton.js



const EnterFullscreenIcon = (0,Icons/* createIcon */.IU)("EnterFullscreen", react.createElement("path", { d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" }));
const ExitFullscreenIcon = (0,Icons/* createIcon */.IU)("ExitFullscreen", react.createElement("path", { d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" }));
const FullscreenButton = ({ auto, labels, render }) => {
    const [mounted, setMounted] = react.useState(false);
    const [fullscreen, setFullscreen] = react.useState(false);
    const containerRef = useFullscreen();
    const isFullscreenEnabled = () => {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = document.fullscreenEnabled) !== null && _a !== void 0 ? _a : document.webkitFullscreenEnabled) !== null && _b !== void 0 ? _b : document.mozFullScreenEnabled) !== null && _c !== void 0 ? _c : document.msFullscreenEnabled) !== null && _d !== void 0 ? _d : false;
    };
    const getFullscreenElement = react.useCallback(() => {
        var _a, _b, _c;
        return (_c = (_b = (_a = document.fullscreenElement) !== null && _a !== void 0 ? _a : document.webkitFullscreenElement) !== null && _b !== void 0 ? _b : document.mozFullScreenElement) !== null && _c !== void 0 ? _c : document.msFullscreenElement;
    }, []);
    const requestFullscreen = react.useCallback(() => {
        const container = containerRef.current;
        if (container) {
            try {
                if (container.requestFullscreen) {
                    container.requestFullscreen().catch(() => { });
                }
                else if (container.webkitRequestFullscreen) {
                    container.webkitRequestFullscreen();
                }
                else if (container.mozRequestFullScreen) {
                    container.mozRequestFullScreen();
                }
                else if (container.msRequestFullscreen) {
                    container.msRequestFullscreen();
                }
            }
            catch (err) {
            }
        }
    }, [containerRef]);
    const exitFullscreen = react.useCallback(() => {
        if (getFullscreenElement()) {
            try {
                if (document.exitFullscreen) {
                    document.exitFullscreen().catch(() => { });
                }
                else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
                else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                }
                else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
            catch (err) {
            }
        }
    }, [getFullscreenElement]);
    const toggleFullscreen = react.useCallback(() => {
        if (fullscreen) {
            exitFullscreen();
        }
        else {
            requestFullscreen();
        }
    }, [fullscreen, requestFullscreen, exitFullscreen]);
    const fullscreenChangeListener = react.useCallback(() => {
        if (getFullscreenElement() === containerRef.current) {
            setFullscreen(true);
        }
        else {
            setFullscreen(false);
        }
    }, [containerRef, getFullscreenElement]);
    react.useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);
    react.useEffect(() => {
        const events = ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"];
        events.forEach((event) => {
            document.addEventListener(event, fullscreenChangeListener);
        });
        return () => {
            events.forEach((event) => {
                document.removeEventListener(event, fullscreenChangeListener);
            });
        };
    }, [fullscreenChangeListener]);
    const handleAutoFullscreen = (0,useEventCallback/* useEventCallback */.$)(() => {
        if (auto) {
            requestFullscreen();
        }
    });
    react.useEffect(() => {
        handleAutoFullscreen();
        return () => {
            exitFullscreen();
        };
    }, [handleAutoFullscreen, exitFullscreen]);
    if (!mounted || !isFullscreenEnabled())
        return null;
    return render.buttonFullscreen ? (react.createElement(react.Fragment, null, render.buttonFullscreen({ fullscreen, toggleFullscreen }))) : (react.createElement(IconButton/* IconButton */.h, { label: fullscreen ? (0,utils/* label */.PS)(labels, "Exit Fullscreen") : (0,utils/* label */.PS)(labels, "Enter Fullscreen"), icon: fullscreen ? ExitFullscreenIcon : EnterFullscreenIcon, renderIcon: fullscreen ? render.iconExitFullscreen : render.iconEnterFullscreen, onClick: toggleFullscreen }));
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/fullscreen/Fullscreen.js




const Fullscreen = ({ augment, contains, addParent }) => {
    augment(({ toolbar: { buttons, ...restToolbar }, ...restProps }) => ({
        toolbar: {
            buttons: [
                react.createElement(FullscreenButton, { key: consts/* PLUGIN_FULLSCREEN */.zr, auto: Boolean(restProps.fullscreen), labels: restProps.labels, render: restProps.render }),
                ...buttons,
            ],
            ...restToolbar,
        },
        ...restProps,
    }));
    addParent(contains(consts/* PLUGIN_THUMBNAILS */.dA) ? consts/* PLUGIN_THUMBNAILS */.dA : consts/* MODULE_CONTROLLER */.l4, (0,config/* createModule */.l6)(consts/* PLUGIN_FULLSCREEN */.zr, FullscreenContextProvider));
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/fullscreen/index.js

/* harmony default export */ var fullscreen = (Fullscreen);


/***/ }),

/***/ 52806:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ thumbnails; }
});

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/config.js
var config = __webpack_require__(36615);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/consts.js
var consts = __webpack_require__(97678);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/utils.js
var utils = __webpack_require__(45746);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/utils.js


const cssPrefix = (value) => (0,utils/* composePrefix */.Xl)(consts/* PLUGIN_THUMBNAILS */.dA, value);
const cssThumbnailPrefix = (value) => cssPrefix((0,utils/* composePrefix */.Xl)("thumbnail", value));

// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/LightboxState.js
var LightboxState = __webpack_require__(12986);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/Events.js
var Events = __webpack_require__(31390);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useMotionPreference.js
var useMotionPreference = __webpack_require__(6404);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useRTL.js
var useRTL = __webpack_require__(81969);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useEventCallback.js
var useEventCallback = __webpack_require__(83744);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(6269);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/components/Icons.js
var Icons = __webpack_require__(26668);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/components/ImageSlide.js
var ImageSlide = __webpack_require__(18733);
;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/Thumbnail.js



const VideoThumbnailIcon = (0,Icons/* createIcon */.IU)("VideoThumbnail", react.createElement("path", { d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" }));
const UnknownThumbnailIcon = (0,Icons/* createIcon */.IU)("UnknownThumbnail", react.createElement("path", { d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z" }));
const renderThumbnail = ({ slide, render, rect, imageFit }) => {
    var _a;
    const customThumbnail = (_a = render.thumbnail) === null || _a === void 0 ? void 0 : _a.call(render, { slide, render, rect, imageFit });
    if (customThumbnail) {
        return customThumbnail;
    }
    const thumbnailIconClass = (0,utils/* cssClass */.Nc)(cssThumbnailPrefix(consts/* ELEMENT_ICON */.vg));
    if (!(0,utils/* isImageSlide */.QB)(slide)) {
        if (slide.type === "video") {
            return (react.createElement(react.Fragment, null,
                "poster" in slide && (react.createElement("img", { alt: "", src: slide.poster, className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(consts/* CLASS_FULLSIZE */.yS), (0,utils/* cssClass */.Nc)(cssPrefix("contain_image"))) })),
                react.createElement(VideoThumbnailIcon, { className: thumbnailIconClass })));
        }
    }
    else {
        return react.createElement(ImageSlide/* ImageSlide */.P, { slide: slide, render: render, rect: rect, imageFit: imageFit });
    }
    return react.createElement(UnknownThumbnailIcon, { className: thumbnailIconClass });
};
const activePrefix = (0,utils/* makeComposePrefix */.cO)("active");
const fadeInPrefix = (0,utils/* makeComposePrefix */.cO)("fadein");
const fadeOutPrefix = (0,utils/* makeComposePrefix */.cO)("fadeout");
const placeholderPrefix = (0,utils/* makeComposePrefix */.cO)("placeholder");
const DELAY = "delay";
const DURATION = "duration";
const Thumbnail = ({ rect, slide, onClick, active, fadeIn, fadeOut, placeholder, render, imageFit, style, }) => (react.createElement("button", { type: "button", className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(consts/* CLASS_FLEX_CENTER */.aN), (0,utils/* cssClass */.Nc)(cssThumbnailPrefix()), active && (0,utils/* cssClass */.Nc)(cssThumbnailPrefix(activePrefix())), fadeIn && (0,utils/* cssClass */.Nc)(cssThumbnailPrefix(fadeInPrefix())), fadeOut && (0,utils/* cssClass */.Nc)(cssThumbnailPrefix(fadeOutPrefix())), placeholder && (0,utils/* cssClass */.Nc)(cssThumbnailPrefix(placeholderPrefix()))), style: {
        ...(fadeIn
            ? {
                [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix(fadeInPrefix(DURATION)))]: `${fadeIn.duration}ms`,
                [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix(fadeInPrefix(DELAY)))]: `${fadeIn.delay}ms`,
            }
            : null),
        ...(fadeOut
            ? {
                [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix(fadeOutPrefix(DURATION)))]: `${fadeOut.duration}ms`,
                [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix(fadeOutPrefix(DELAY)))]: `${fadeOut.delay}ms`,
            }
            : null),
        ...style,
    }, onClick: onClick }, slide && renderThumbnail({ slide, render, rect, imageFit })));

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/ThumbnailsTrack.js





const isHorizontal = (position) => ["top", "bottom"].includes(position);
const boxSize = (thumbnails, dimension, includeGap) => dimension + 2 * (thumbnails.border + thumbnails.padding) + (includeGap ? thumbnails.gap : 0);
const getSlide = (slides, index) => slides[((index % slides.length) + slides.length) % slides.length];
const ThumbnailsTrack = ({ container, startingIndex, slides, carousel, render, thumbnails, thumbnailRect, styles, }) => {
    const [index, setIndex] = react.useState(startingIndex);
    const [offset, setOffset] = react.useState(0);
    const track = react.useRef(null);
    const animationRef = react.useRef();
    const animationOffset = react.useRef(0);
    const { state: { globalIndex, animationDuration }, } = (0,LightboxState/* useLightboxState */.o)();
    const { publish } = (0,Events/* useEvents */.h)();
    const reduceMotion = (0,useMotionPreference/* useMotionPreference */.O)();
    const isRTL = (0,useRTL/* useRTL */.S)();
    const handleControllerSwipe = (0,useEventCallback/* useEventCallback */.$)(() => {
        if (container.current && track.current) {
            const containerRect = container.current.getBoundingClientRect();
            const trackRect = track.current.getBoundingClientRect();
            animationOffset.current = isHorizontal(thumbnails.position)
                ? trackRect.left - (containerRect.width - trackRect.width) / 2
                : trackRect.top - (containerRect.height - trackRect.height) / 2;
        }
        else {
            animationOffset.current = 0;
        }
        setIndex(globalIndex);
        setOffset(globalIndex - index);
    });
    react.useEffect(handleControllerSwipe, [globalIndex, handleControllerSwipe]);
    const getCurrentIndex = (0,useEventCallback/* useEventCallback */.$)(() => index);
    const handleIndexOffsetChange = (0,useEventCallback/* useEventCallback */.$)(() => {
        var _a, _b, _c;
        if (track.current && offset) {
            (_a = animationRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
            animationRef.current = (_c = (_b = track.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, isHorizontal(thumbnails.position)
                ? [
                    {
                        transform: `translateX(${(isRTL ? -1 : 1) * boxSize(thumbnails, thumbnails.width, true) * offset +
                            animationOffset.current}px)`,
                    },
                    { transform: "translateX(0)" },
                ]
                : [
                    {
                        transform: `translateY(${boxSize(thumbnails, thumbnails.height, true) * offset + animationOffset.current}px)`,
                    },
                    { transform: "translateY(0)" },
                ], !reduceMotion ? animationDuration : 0);
            if (animationRef.current) {
                animationRef.current.onfinish = () => {
                    animationRef.current = undefined;
                    if (getCurrentIndex() === index) {
                        setOffset(0);
                    }
                };
            }
            animationOffset.current = 0;
        }
    });
    (0,useLayoutEffect/* useLayoutEffect */.b)(handleIndexOffsetChange, [index, offset, handleIndexOffsetChange]);
    const { finite, preload } = carousel;
    const items = [];
    if (slides.length > 0) {
        if (offset < 0) {
            for (let i = index - preload + offset; i < index - preload; i += 1) {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
        for (let i = index - preload - (offset > 0 ? offset : 0); i < index; i += 1) {
            if (!(finite && i < 0)) {
                items.push({ slide: getSlide(slides, i), index: i });
            }
            else {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
        items.push({ slide: getSlide(slides, index), index });
        for (let i = index + 1; i <= index + preload - (offset < 0 ? offset : 0); i += 1) {
            if (!finite || i <= slides.length - 1) {
                items.push({ slide: getSlide(slides, i), index: i });
            }
            else {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
        if (offset > 0) {
            for (let i = index + preload + 1; i <= index + preload + offset; i += 1) {
                items.push({ slide: null, index: i, placeholder: true });
            }
        }
    }
    const handleClick = (slideIndex) => () => {
        if (slideIndex > index) {
            publish(consts/* ACTION_NEXT */.Eb, slideIndex - index);
        }
        else if (slideIndex < index) {
            publish(consts/* ACTION_PREV */.KN, index - slideIndex);
        }
    };
    const { width, height, border, borderRadius, padding, gap, imageFit, vignette } = thumbnails;
    return (react.createElement("div", { className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(cssPrefix("container")), (0,utils/* cssClass */.Nc)(consts/* CLASS_FLEX_CENTER */.aN)), style: {
            ...(width !== defaultThumbnailsProps.width
                ? { [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix("width"))]: `${boxSize(thumbnails, width)}px` }
                : null),
            ...(height !== defaultThumbnailsProps.height
                ? { [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix("height"))]: `${boxSize(thumbnails, height)}px` }
                : null),
            ...(border !== defaultThumbnailsProps.border
                ? { [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix("border"))]: `${border}px` }
                : null),
            ...(borderRadius !== defaultThumbnailsProps.borderRadius
                ? { [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix("border_radius"))]: `${borderRadius}px` }
                : null),
            ...(padding !== defaultThumbnailsProps.padding
                ? { [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix("padding"))]: `${padding}px` }
                : null),
            ...(gap !== defaultThumbnailsProps.gap ? { [(0,utils/* cssVar */.gJ)(cssThumbnailPrefix("gap"))]: `${gap}px` } : null),
            ...styles.thumbnailsContainer,
        } },
        react.createElement("nav", { ref: track, style: styles.thumbnailsTrack, className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(cssPrefix("track")), (0,utils/* cssClass */.Nc)(consts/* CLASS_FLEX_CENTER */.aN)) }, items.map(({ slide, index: slideIndex, placeholder }) => {
            const fadeAnimationDuration = animationDuration / Math.abs(offset || 1);
            const fadeIn = (offset > 0 && slideIndex > index + preload - offset && slideIndex <= index + preload) ||
                (offset < 0 && slideIndex < index - preload - offset && slideIndex >= index - preload)
                ? {
                    duration: fadeAnimationDuration,
                    delay: ((offset > 0
                        ? slideIndex - (index + preload - offset)
                        : index - preload - offset - slideIndex) -
                        1) *
                        fadeAnimationDuration,
                }
                : undefined;
            const fadeOut = (offset > 0 && slideIndex < index - preload) || (offset < 0 && slideIndex > index + preload)
                ? {
                    duration: fadeAnimationDuration,
                    delay: (offset > 0
                        ? offset - (index - preload - slideIndex)
                        : -offset - (slideIndex - (index + preload))) * fadeAnimationDuration,
                }
                : undefined;
            return (react.createElement(Thumbnail, { key: slideIndex, rect: thumbnailRect, slide: slide, imageFit: imageFit, render: render, active: slideIndex === index, fadeIn: fadeIn, fadeOut: fadeOut, placeholder: Boolean(placeholder), onClick: handleClick(slideIndex), style: styles.thumbnail }));
        })),
        vignette && react.createElement("div", { className: (0,utils/* cssClass */.Nc)(cssPrefix("vignette")) })));
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/ThumbnailsContainer.js





const ThumbnailsComponent = ({ thumbnails: thumbnailsProps, slides, index, carousel, animation, render, styles, children, }) => {
    const thumbnails = { ...defaultThumbnailsProps, ...thumbnailsProps };
    const ref = react.useRef(null);
    const track = (react.createElement(ThumbnailsTrack, { container: ref, slides: slides, thumbnails: thumbnails, carousel: carousel, animation: animation, render: render, startingIndex: index, thumbnailRect: { width: thumbnails.width, height: thumbnails.height }, styles: styles }));
    return (react.createElement("div", { ref: ref, className: (0,utils/* clsx */.Wy)((0,utils/* cssClass */.Nc)(cssPrefix()), (0,utils/* cssClass */.Nc)(cssPrefix(`${thumbnails.position}`))) },
        (thumbnails.position === "start" || thumbnails.position === "top") && track,
        react.createElement("div", { className: (0,utils/* cssClass */.Nc)(cssPrefix("wrapper")) }, children),
        (thumbnails.position === "end" || thumbnails.position === "bottom") && track));
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/Thumbnails.js


const defaultThumbnailsProps = {
    position: "bottom",
    width: 120,
    height: 80,
    border: 1,
    borderRadius: 4,
    padding: 4,
    gap: 16,
    imageFit: "contain",
    vignette: true,
};
const Thumbnails = ({ augment, contains, append, addParent }) => {
    augment(({ thumbnails, ...restProps }) => ({
        thumbnails: {
            ...defaultThumbnailsProps,
            ...thumbnails,
        },
        ...restProps,
    }));
    const module = (0,config/* createModule */.l6)(consts/* PLUGIN_THUMBNAILS */.dA, ThumbnailsComponent);
    if (contains(consts/* PLUGIN_FULLSCREEN */.zr)) {
        append(consts/* PLUGIN_FULLSCREEN */.zr, module);
    }
    else {
        addParent(consts/* MODULE_CONTROLLER */.l4, module);
    }
};

;// CONCATENATED MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/index.js

/* harmony default export */ var thumbnails = (Thumbnails);


/***/ })

}]);